// ---------------------------------------------------------
// App Helper
// ---------------------------------------------------------
import './app';

// ---------------------------------------------------------
// Components load on demand
// ---------------------------------------------------------
import './load-on-demand';

// ---------------------------------------------------------
// Components
// ---------------------------------------------------------
import './frontend';
import './backend';

var chartEl = document.getElementById('jsChart'),
  chart = null,
  chartCategory = 'weight',
  chartType = 'week',
  chartBackground = '#9ADCFF',
  chartColor = '#9ADCFF',
  chartData = null,
  healthcares = null,
  chartDatas = null,
  ctx = null;

function hexToRGBA(hexCode, opacity) {
  var hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  var r = parseInt(hex.substring(0, 2), 16),
    g = parseInt(hex.substring(2, 4), 16),
    b = parseInt(hex.substring(4, 6), 16);

  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
}

function gradientMaker(from, to) {
  var gradient = ctx.createLinearGradient(0, 0, 0, 500);
  gradient.addColorStop(0, from);
  gradient.addColorStop(1, to);
  return gradient;
}

function getChartData(category, type) {
  var data = {};
  for (var i = 0; i < chartDatas.length; i++) {
    if (chartDatas[i].category == category) {
      for (var j = 0; j < chartDatas[i].datas.length; j++) {
        if (chartDatas[i].datas[j].type == type) {
          chartColor = chartDatas[i].color;
          chartBackground = chartDatas[i].background;
          data = chartDatas[i].datas[j];
        }
      }
    }
  }
  return data;
}

function removeCurrent(arr) {
  for (var i = 0; i < arr.length; i++) {
    arr[i].classList.remove('current');
  }
}

function updateChart() {
  chartData = getChartData(chartCategory, chartType);
  var chartDataSet = {
    data: chartData.values,
    backgroundColor: gradientMaker(hexToRGBA(chartBackground, 100), hexToRGBA(chartBackground, 0)),
    borderColor: hexToRGBA(chartColor, 100),
    fontColor: '#fff',
    borderWidth: 4,
    pointBackgroundColor: hexToRGBA(chartColor, 100),
    pointBorderWidth: 0,
  };
  chart.data.datasets.pop();
  chart.data.labels = chartData.labels;
  chart.options.scales.yAxes[0].ticks.min = chartData.minY;
  chart.options.scales.yAxes[0].ticks.max = chartData.maxY;
  chart.options.scales.yAxes[0].ticks.stepSize = chartData.step;
  chart.data.datasets.push(chartDataSet);
  chart.options.annotation.annotations.pop();
  chart.options.annotation.annotations.push({
    type: 'line',
    mode: 'horizontal',
    scaleID: 'y-axis-0',
    value: chartData.average,
    borderColor: chartBackground,
    borderWidth: 4,
    borderDash: [4, 4],
    label: {
      backgroundColor: chartBackground,
      fontSize: 18,
      fontStyle: '700',
      fontColor: '#fff',
      xPadding: 10,
      yPadding: 8,
      cornerRadius: 25,
      position: 'left',
      xAdjust: 50,
      yAdjust: 0,
      enabled: true,
      content: chartData.average
    },
  });
  chartResize();
}

function chartResize() {
  if (window.innerWidth <= 768) {
    chart.options.layout.padding.top = 15;
    chart.options.layout.padding.right = 15;
    chart.options.layout.padding.bottom = 15;
    chart.options.layout.padding.left = 15;
    chart.options.scales.yAxes[0].ticks.padding = 15;
    chart.options.scales.yAxes[0].ticks.fontSize = 15;
    chart.options.scales.xAxes[0].ticks.padding = 15;
    chart.options.scales.xAxes[0].ticks.fontSize = 13;
    chart.options.scales.xAxes[0].ticks.min = chartData.labels[chartData.labels.length >= 7 ? chartData.labels.length - 7 : 0];
    chart.options.scales.xAxes[0].ticks.max = chartData.labels[chartData.labels.length];
    chart.options.elements.point.radius = 5;
    chart.options.elements.point.hoverRadius = 5;
    chart.data.datasets[0].borderWidth = 2;
    chart.options.annotation.annotations.pop();
    chart.options.annotation.annotations.push({
      type: 'line',
      mode: 'horizontal',
      scaleID: 'y-axis-0',
      value: chartData.average,
      borderColor: chartBackground,
      borderWidth: 2,
      borderDash: [2, 2],
      label: {
        backgroundColor: chartBackground,
        fontSize: 13,
        fontStyle: '700',
        fontColor: '#fff',
        xPadding: 10,
        yPadding: 5,
        cornerRadius: 25,
        position: 'left',
        xAdjust: 25,
        yAdjust: 0,
        enabled: true,
        content: chartData.average
      },
    });
  } else {
    chart.options.layout.padding.top = 50;
    chart.options.layout.padding.right = 50;
    chart.options.layout.padding.bottom = 50;
    chart.options.layout.padding.left = 50;
    chart.options.scales.yAxes[0].ticks.padding = 25;
    chart.options.scales.yAxes[0].ticks.fontSize = 20;
    chart.options.scales.xAxes[0].ticks.padding = 25;
    chart.options.scales.xAxes[0].ticks.fontSize = 14;
    chart.options.scales.xAxes[0].ticks.max = chartData.labels[chartData.labels.length];
    chart.options.scales.xAxes[0].ticks.min = chartData.labels[0];
    chart.options.elements.point.radius = 9;
    chart.options.elements.point.hoverRadius = 9;
    chart.data.datasets[0].borderWidth = 4;
    chart.options.annotation.annotations.pop();
    chart.options.annotation.annotations.push({
      type: 'line',
      mode: 'horizontal',
      scaleID: 'y-axis-0',
      value: chartData.average,
      borderColor: chartBackground,
      borderWidth: 4,
      borderDash: [4, 4],
      label: {
        backgroundColor: chartBackground,
        fontSize: 18,
        fontStyle: '700',
        fontColor: '#fff',
        xPadding: 10,
        yPadding: 8,
        cornerRadius: 25,
        position: 'left',
        xAdjust: 50,
        yAdjust: 0,
        enabled: true,
        content: chartData.average
      },
    });
  }
  chart.update();
}

window.addEventListener('load', function() {
  if(window.location.pathname !== '/mypage/healthcare') return;
  $.ajax({
    url: '/mypage/healthcare/chart',
    type: 'GET',
    async: false,
    success: function(data) {
      healthcares = data;
      chartDatas = [{
        category: 'weight',
        color: '#9ADCFF',
        background: '#0E98E0',
        datas: [{
          type: 'week',
          labels: healthcares.weight.week.label,
          values: healthcares.weight.week.values,
          average: healthcares.weight.week.average,
          step: healthcares.weight.week.step,
          minY: healthcares.weight.week.minY,
          maxY: healthcares.weight.week.maxY,
        }, {
          type: 'month',
          labels: healthcares.weight.month.label,
          values: healthcares.weight.month.values,
          average: healthcares.weight.month.average,
          step: healthcares.weight.month.step,
          minY: healthcares.weight.month.minY,
          maxY: healthcares.weight.month.maxY,
        }, {
          type: 'year',
          labels: healthcares.weight.year.label,
          values: healthcares.weight.year.values,
          average: healthcares.weight.year.average,
          step: healthcares.weight.year.step,
          minY: healthcares.weight.year.minY,
          maxY: healthcares.weight.year.maxY,
        }]
      }, {
        category: 'percent',
        color: '#FF9AEF',
        background: '#FF9AEF',
        datas: [{
          type: 'week',
          labels: healthcares.fat.week.label,
          values: healthcares.fat.week.values,
          average: null,
          step: healthcares.fat.week.step,
          minY: healthcares.fat.week.minY,
          maxY: healthcares.fat.week.maxY,
        }, {
          type: 'month',
          labels: healthcares.fat.month.label,
          values: healthcares.fat.month.values,
          average: null,
          step: healthcares.fat.month.step,
          minY: healthcares.fat.month.minY,
          maxY: healthcares.fat.month.maxY,
        }, {
          type: 'year',
          labels: healthcares.fat.year.label,
          values: healthcares.fat.year.values,
          average: null,
          step: healthcares.fat.year.step,
          minY: healthcares.fat.year.minY,
          maxY: healthcares.fat.year.maxY,
        }]
      }, {
        category: 'bmi',
        color: '#FFF39A',
        background: '#FFF39A',
        datas: [{
          type: 'week',
          labels: healthcares.bmi.week.label,
          values: healthcares.bmi.week.values,
          average: healthcares.bmi.week.average,
          step: healthcares.bmi.week.step,
          minY: healthcares.bmi.week.minY,
          maxY: healthcares.bmi.week.maxY,
        }, {
          type: 'month',
          labels: healthcares.bmi.month.label,
          values: healthcares.bmi.month.values,
          average: healthcares.bmi.month.average,
          step: healthcares.bmi.month.step,
          minY: healthcares.bmi.month.minY,
          maxY: healthcares.bmi.month.maxY,
        }, {
          type: 'year',
          labels: healthcares.bmi.year.label,
          values: healthcares.bmi.year.values,
          average: healthcares.bmi.year.average,
          step: healthcares.bmi.year.step,
          minY: healthcares.bmi.year.minY,
          maxY: healthcares.bmi.year.maxY,
        }]
      }];

      if (chartEl) {
        chartData = getChartData('weight', 'week'),
          ctx = chartEl.getContext('2d');
        chart = new Chart(ctx, {
          type: 'line',
          responsive: true,
          data: {
            labels: chartData.labels,
            datasets: [{
              data: chartData.values,
              backgroundColor: gradientMaker(hexToRGBA(chartBackground, 100), hexToRGBA(chartBackground, 0)),
              borderColor: hexToRGBA(chartColor, 100),
              fontColor: '#fff',
              borderWidth: 4,
              pointBackgroundColor: hexToRGBA(chartColor, 100),
              pointBorderWidth: 0,
            }]
          },
          options: {
            spanGaps: true,
            layout: {
              padding: {
                top: 50,
                right: 50,
                bottom: 50,
                left: 50,
              },
            },
            elements: {
              point: {
                radius: 9,
                hoverRadius: 9
              },
              rectangle: {
                borderWidth: 2,
                borderColor: 'rgb(0, 255, 0)',
                borderSkipped: 'bottom'
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: false,
                  stepSize: chartData.step,
                  min: chartData.minY,
                  max: chartData.maxY,
                  padding: 25,
                  fontSize: 20,
                  fontColor: '#fff',
                },
                gridLines: {
                  color: '#7684A0',
                  drawBorder: false,
                },
              }],
              xAxes: [{
                ticks: {
                  padding: 25,
                  fontSize: 14,
                  fontColor: '#fff',
                  min: chartData.labels[0],
                },
                gridLines: {
                  display: false,
                },
              }],
            },
            legend: {
              display: false,
              labels: {
                fontColor: '#fff'
              }
            },
            annotation: {
              annotations: [{
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-0',
                value: chartData.average,
                borderColor: chartBackground,
                borderWidth: 4,
                borderDash: [4, 4],
                label: {
                  backgroundColor: chartBackground,
                  fontSize: 18,
                  fontStyle: '700',
                  fontColor: '#fff',
                  xPadding: 10,
                  yPadding: 8,
                  cornerRadius: 25,
                  position: 'left',
                  xAdjust: 50,
                  yAdjust: 0,
                  enabled: true,
                  content: chartData.average
                },
              }]
            },
            plugins: {
              zoom: {
                pan: {
                  enabled: true,
                  speed: 2,
                  mode: 'x'
                },
                zoom: {
                  enabled: true,
                  mode: 'x',
                  sensitivity: 3
                }
              }
            }
          },
        });
        var chartCategoryItems = document.querySelectorAll('.jsChartSelectItem'),
          chartCategoryValueEl = document.getElementById('jsChartCategoryValue'),
          chartTypeItems = document.querySelectorAll('.jsChartTypeItem'),
          chartName = document.getElementById('chartName');
        for (var i = 0; i < chartCategoryItems.length; i++) {
          chartCategoryItems[i].addEventListener('click', function() {
            chartCategory = this.dataset.category;
            chartCategoryValueEl.dataset.category = this.dataset.category;
            chartCategoryValueEl.innerHTML = this.innerText;
            chartName.innerHTML = this.innerText;
            removeCurrent(chartCategoryItems);
            updateChart();
            this.classList.add('current');
          });
        }
        for (var i = 0; i < chartTypeItems.length; i++) {
          chartTypeItems[i].addEventListener('click', function() {
            chartType = this.dataset.type;
            removeCurrent(chartTypeItems);
            updateChart();
            this.classList.add('current');
          });
        }
        chartResize();
      }
    },
    error: function(e) {
    }
  });
});

window.addEventListener('resize', function() {
  chartResize();
});